import { render, staticRenderFns } from "./ProductExistAlso.vue?vue&type=template&id=0b615633&"
import script from "./ProductExistAlso.vue?vue&type=script&lang=js&"
export * from "./ProductExistAlso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports